import * as React from 'react';
import { useEffect, useState } from 'react';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import VideoManager from '../../Managers/VideoManager';
import "./VideoPlayer.css";
import videojs from 'video.js';
import VREPlayer from 'videojs-react-enhanced';
import 'video.js/dist/video-js.css';
import { Collapse } from '@material-ui/core';
import { useContext } from 'react';
import { VideoContext } from '../../Context';


export const VideoPlayer = prop => {
    const [options, setOptions] = useState<IPlayerOptions>(
        {
            src: null,
            controls: true, 
            autoplay: "play",
        }
    )
    const { url  } = useContext(VideoContext)
        console.log(url)
    useEffect(()=> {
    
        const _options = {...options}
        _options.src = url
        setOptions(_options)

    }, [url])

    const videojsOptions = {
      fluid: true,
    };


    return(
        <div className="video-player-container">
            <Collapse in={!!options.src} timeout={1000}>
            {!!options.src && <VREPlayer
                playerOptions={options}
                videojsOptions={videojsOptions}
                onReady={() => console.log("ready")}
                onPlay={(e, _, second) => console.log('Play!')}
                onPause={(e, _, second) => console.log('Pause!')}
                onEnded={(e, _) => console.log('Ended!')}
                onError={console.error}
            />
            }
            </Collapse>
        </div>
    )
}

interface IPlayerOptions {
    autoplay?: 'muted' | 'play' | 'any';
    controls?: boolean;
    height?: number;
    loop?: boolean;
    muted?: boolean;
    playsinline?: boolean;
    preload?: 'auto' | 'metadata' | 'none';
    src?: string;
    width?: number;
}